import styles from "./VariantSelector.module.scss";

type VariantSelectorProps = {
  color: string;
  label: string;
};

export const VariantSelector = ({ color, label }: VariantSelectorProps) => (
  <span className={styles.container}>
    <span
      aria-label={label}
      className={styles.radio}
      role="button"
      style={{
        backgroundColor: color,
      }}
    />
  </span>
);
